import styled, { css } from 'styled-components';
import { px2rem } from '../utils/helpers/style.js';
import { getButtonStyles } from '../Button/utils.js';
import { styles } from '../constants/styles.js';
import { boxStyles } from '../Box/styles.js';
import { fontFamilyStyles } from '../ContentText/styles.web.js';
import { boxStyledOptions } from '../utils/helpers/styled.js';
import { generateColorLuminances } from '../utils/helpers/generateColorLuminances.js';

var pagination = /*#__PURE__*/styled.ul.withConfig(boxStyledOptions).withConfig({
  displayName: "styles__pagination",
  componentId: "sc-gtgi9i-0"
})(["font-size:", ";", ";"], px2rem(18), boxStyles);
var item = /*#__PURE__*/styled.li.withConfig({
  displayName: "styles__item",
  componentId: "sc-gtgi9i-1"
})(["display:inline-block;position:relative;&:first-child{span{position:absolute;right:50%;top:50%;transform:scaleX(-1) translate(-50%,-50%);}}&:last-child{span{position:absolute;left:50%;top:50%;transform:translate(-50%,-50%);}}width:", ";", "{width:", ";}&:after{content:'';display:block;padding-bottom:100%;}"], px2rem(36), styles.breakpoint.s, px2rem(48));
var truncated = /*#__PURE__*/styled.span.withConfig({
  displayName: "styles__truncated",
  componentId: "sc-gtgi9i-2"
})(["color:", ";font-size:", ";left:0;position:absolute;top:50%;text-align:center;transform:translateY(-50%);width:100%;"], function (p) {
  return p.theme.pagination.web.ellipsisColor;
}, px2rem(18));
var button = /*#__PURE__*/styled.button.withConfig({
  displayName: "styles__button",
  componentId: "sc-gtgi9i-3"
})(["", ";outline:none;border:none;::-moz-focus-inner{border:none;}color:", ";padding:0;margin:auto;background:", ";border-radius:", ";cursor:pointer;font-size:", ";position:absolute;height:100%;width:100%;display:flex;align-items:center;justify-content:center;text-decoration:none;&:disabled{opacity:0;pointer-events:none;}", " &:focus-visible{box-shadow:0 0 0 4px ", ";outline:2px solid ", ";outline-offset:0;}"], fontFamilyStyles, function (props) {
  var luminances = generateColorLuminances('normal', props.theme, {
    color: props.$color
  });
  return props.$active ? luminances.fg : props.$color;
}, function (props) {
  return props.$active ? props.$color : 'transparent';
}, function (props) {
  return props.theme.pagination.web.button.borderRadius;
}, px2rem(18), function (props) {
  return !props.$active && css(["&:focus,&:hover{", " color:", ";}&:active{", " color:", ";}"], getButtonStyles('focus')({
    $status: 'plain',
    theme: props.theme,
    $color: props.$color
  }), props.$color, getButtonStyles('click')({
    $status: 'plain',
    theme: props.theme,
    $color: props.$color
  }), props.$color);
}, function (p) {
  return p.theme.tokens.focus.primary;
}, function (p) {
  return p.theme.tokens.focus.secondary;
});

export { button, item, pagination, truncated };
